module.exports = __webpack_public_path__ + "img/num_2.48a3f566.png";